import React from "react";
import { PageLayout } from "../../components";
import { useCustomerConfirmation } from "./useCustomerConfirmation";
import { CustomerConfirmationDetails } from "./components/CustomerConfirmationDetails";
import { ConfirmationLoader } from "../../components/SkeletonLoaders/ConfirmationLoader";

const ConfirmationContainer = ({
  confirmationType
}: {
  confirmationType: string;
}) => {
  const {
    customerConfirmationDetails: {
      title,
      subtitle,
      onSubmit,
      buttonCopy,
      analyticsLabel
    },
    stepCount,
    readyToRender
  } = useCustomerConfirmation(confirmationType);

  return (
    <PageLayout>
      <PageLayout.Header title="Next steps" step={stepCount} />

      <PageLayout.Content backgroundColour={null}>
        {readyToRender ? (
          <CustomerConfirmationDetails
            title={title}
            subtitle={subtitle}
            onSubmit={onSubmit}
            buttonCopy={buttonCopy}
            analyticsLabel={analyticsLabel}
          />
        ) : (
          <ConfirmationLoader />
        )}
      </PageLayout.Content>
    </PageLayout>
  );
};

export default ConfirmationContainer;
